/**
 * Safe internal redirect helper — never allow open redirects.
 */
export function safeInternalPath(
  candidate: string | null | undefined,
  fallback = '/pricing'
): string {
  if (!candidate) return fallback;
  const trimmed = candidate.trim();
  if (!trimmed.startsWith('/')) return fallback;
  if (trimmed.startsWith('//')) return fallback;
  if (trimmed.includes('://')) return fallback;
  if (trimmed.includes('\\')) return fallback;
  // Block protocol-relative and scheme smuggling
  if (/[\r\n]/.test(trimmed)) return fallback;
  return trimmed;
}

export function isPaidPlanId(value: string | null | undefined): value is 'creator' | 'studio' {
  return value === 'creator' || value === 'studio';
}

/** Persist selected checkout plan across Pricing → auth → Pricing. */
export const CHECKOUT_PLAN_STORAGE_KEY = 'aimakerstudio_checkout_plan';
